import React, { useState } from 'react';
import TabContext from '@mui/lab/TabContext';

import { useSelector } from 'react-redux';
import { selectCommandByNodeId, State } from '@store/index';
import { TabList, TabPanel } from '@mui/lab';
import { Divider, Tab } from '@mui/material';
import { NodeInputExpression, NodeSidebar, NodeSidebarTab, NodeSidebarTabsContainer } from '@common/Node/NodeSidebar';
import { ArticleOutlined } from '@mui/icons-material';
import { NodeData } from '@common/Node/NodeSidebar/NodeData';
import { useTheme } from '../../../../../styles';
import { NodeFieldType, SendMessageNodeState } from '../../types';
import { Toggle } from '@common/Node/NodeSidebar/Custom/Toggle';
import { MessagingProfileSelect } from '@common/Node/NodeSidebar/Custom/MessagingProfileSelect';
import { MediaUrls } from '@common/Node/NodeSidebar/Custom/MediaUrls/MediaUrls';

export const SendMessageTabs: React.FC = () => {
  const theme = useTheme();

  const [tab, setTab] = useState('1');

  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  const themeType = useSelector((state: State) => state.flow.theme);

  if (!command) return;

  const fields = command.fields;
  const tabColor = themeType === 'light' ? theme.text.standard : theme.telnyx.citron;

  const state = command.state as SendMessageNodeState;

  const messagingProfileField = fields.find((field) => field.id === 'messaging_profile_id');
  const typeField = fields.find((field) => field.id === 'type');
  const mediaUrlField = fields.find((field) => field.id === 'media_urls');
  const useProfileField = fields.find((field) => field.id === 'use_profile_webhooks');
  const autoDetectField = fields.find((field) => field.id === 'auto_detect');

  const inputs = fields.filter((field) => {
    if (field.tab === '1' && field.type === NodeFieldType.InputExpression) {
      if (field.id.startsWith('webhook_')) return false;
      if (field.id === 'subject' && state.type !== 'MMS') return false;
      return true;
    }
    return false;
  });

  const webhookInputs = fields.filter((field) => field.id.startsWith('webhook_'));

  return (
    <NodeSidebar>
      <TabContext value={tab}>
        <NodeSidebarTabsContainer color={tabColor}>
          <TabList onChange={(_, newTab) => setTab(newTab)}>
            <Tab disableRipple label='Node' value='1' />
            <Tab title='Data' disableRipple iconPosition='start' icon={<ArticleOutlined />} value='2' />
          </TabList>
        </NodeSidebarTabsContainer>
        <TabPanel value='1'>
          <NodeSidebarTab>
            {typeField && <Toggle command={command} field={typeField} />}
            <Divider />
            {messagingProfileField && <MessagingProfileSelect command={command} field={messagingProfileField} />}
            {inputs.map((field) => (
              <NodeInputExpression key={field.id} command={command} field={field} />
            ))}
            {mediaUrlField && state.type === 'MMS' && <MediaUrls command={command} field={mediaUrlField} />}
            <Divider />
            {webhookInputs.map((field) => (
              <NodeInputExpression key={field.id} command={command} field={field} />
            ))}
            {useProfileField && <Toggle command={command} field={useProfileField} />}
            {autoDetectField && <Toggle command={command} field={autoDetectField} />}
            <Divider sx={{ marginBottom: '4rem' }} />
          </NodeSidebarTab>
        </TabPanel>
        <TabPanel value='2'>
          <NodeData command={command} />
        </TabPanel>
      </TabContext>
    </NodeSidebar>
  );
};
